import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import classification from "./modules/classification";
import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    classification,
  },
  getters,
});

export default store;
